import MyService from '../../service';

const ImageApi = {
  uploadHandler: async (file) => {
    const data = new FormData();
    data.set('myImg', { ...file }.originFileObj);
    const result = await MyService.postRequestData('/upload', data, {
      accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    });
    if (result) return result.path;
    return null;
  },
  getByVehicleId: async (vhc_id) => {
    const result = await MyService.getRequestData(
      '/vehicles/image/get-by-vehicle',
      { vhc_tbl_name: 'cx_vhc', vhc_tbl_id: vhc_id }
    );
    if ((result.code = 'success')) return result.data;
    return null;
  },
};
export default ImageApi;
